import {
  ENDPOINT_STATISTICS,
  ENDPOINT_STATISTICS_PARTIES,
} from '@/common/constants';
import { HttpApi } from '@/common/http';
import { IPaginatedResponse } from '@/types/paginated.response';
import { create } from 'zustand';
import type {
  IPartiesAction,
  IPartiesState,
  IReportParty,
  IReportResponse,
} from '../models';

const httpApi = new HttpApi();

const useReportStore = create<IPartiesState & IPartiesAction>((set) => ({
  reports: null,
  reportsPagination: {
    totalElements: 0,
    totalPages: 0,
    page: 1,
    size: 10,
  },
  reportsIsLoading: false,
  reportParties: null,
  reportPartiesIsLoading: false,
  fetchReports: async (params?: Record<string, string | number>) => {
    set({ reportsIsLoading: true });
    try {
      const response = await httpApi.get<IReportResponse>(
        ENDPOINT_STATISTICS,
        params,
      );
      set({
        reports: {
          total: response?.total,
          content: response?.content,
        },
        reportsPagination: {
          totalElements: response?.totalElements,
          totalPages: response?.totalPages,
          page: response.page,
          size: response?.limit!,
        },
      });
    } catch (e) {
      throw e;
    } finally {
      setTimeout(() => {
        set({ reportsIsLoading: false });
      }, 300);
    }
  },
  fetchReportParties: async (params?: Record<string, string>) => {
    set({ reportPartiesIsLoading: true });
    try {
      const response = await httpApi.get<IPaginatedResponse<IReportParty>>(
        ENDPOINT_STATISTICS_PARTIES,
        params,
      );
      // Ensure the response has the required total property
      set({
        reportParties: {
          content: response.content,
          total: response.total || {},
        },
      });
    } catch (e) {
      throw e;
    } finally {
      setTimeout(() => {
        set({ reportPartiesIsLoading: false });
      }, 300);
    }
  },
}));

export default useReportStore;
